import type {
  ChatbotCreate,
  Domain,
  ChatbotSettings,
  ChatbotSummary,
  PromptPreview,
  TransitionResult,
  TurnTrace,
} from './types'

import { api } from '@/lib/api/client'


const base = (ws: string) => `/v1/workspaces/${ws}/chatbots`

export const chatbotsApi = {
  list: (ws: string) => api.get<ChatbotSummary[]>(base(ws)),
  create: (ws: string, body: ChatbotCreate) => api.post<ChatbotSummary>(base(ws), body),
  get: (ws: string, id: string) => api.get<ChatbotSummary>(`${base(ws)}/${id}`),
  archive: (ws: string, id: string) => api.delete<ChatbotSummary>(`${base(ws)}/${id}`),

  readiness: (ws: string, id: string, target: string) =>
    api.get<TransitionResult>(`${base(ws)}/${id}/readiness`, { target }),
  changeStatus: (ws: string, id: string, target: string) =>
    api.post<TransitionResult>(`${base(ws)}/${id}/status/${target}`),

  getSettings: (ws: string, id: string) =>
    api.get<ChatbotSettings>(`${base(ws)}/${id}/settings`),
  updateSettings: (ws: string, id: string, body: Partial<ChatbotSettings>) =>
    api.patch<ChatbotSettings>(`${base(ws)}/${id}/settings`, body),

  promptPreview: (ws: string, id: string) =>
    api.get<PromptPreview>(`${base(ws)}/${id}/prompt-preview`),

  publish: (ws: string, id: string, changeNote?: string) =>
    api.post(`${base(ws)}/${id}/publish`, { change_note: changeNote ?? null }),

  /** Runs one REAL turn through the live pipeline and returns the full trace. */
  playground: (ws: string, botId: string, body: { message: string; history: [string, string][] }) =>
    api.post<TurnTrace>(`/v1/workspaces/${ws}/chatbots/${botId}/playground`, body),

  listDomains: (ws: string, botId: string) =>
    api.get<Domain[]>(`${base(ws)}/${botId}/domains`),

  addDomain: (ws: string, botId: string, domain: string) =>
    api.post<Domain>(`${base(ws)}/${botId}/domains`, { domain }),

  removeDomain: (ws: string, botId: string, domainId: string) =>
    api.delete<void>(`${base(ws)}/${botId}/domains/${domainId}`),
}
